<template>
  <b-nav-item-dropdown
    variant="primary"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      🔐
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Roles
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ rolesDisponibles.length }} disponibles
        </b-badge>
      </div>
    </li>
    <b-overlay
      :show="isbusy"
      opacity="0.50"
      rounded="sm"
    >
      <b-dropdown-item
        v-for="rol in rolesDisponibles"
        :key="rol.id"
        link-class="d-flex align-items-center"
        :disabled="userRol.id == rol.id ? true : false"
        @click="activarPreferencias(rol)"
      >
        <feather-icon
          size="16"
          :icon="userRol.id == rol.id ? 'UnlockIcon' : 'LockIcon'"
          class="mr-50"
        />
        <span class="font-weight-bolder">{{ rol.nombre }} <small>{{ userRol.id == rol.id ? '(seleccionado)' : '' }}</small></span>
      </b-dropdown-item>
    </b-overlay>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BBadge,
  BOverlay,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// import store from '@/store/index'
import useRoles from '@/views/campus/account-data/useRoles'
import { rolesActions } from '@core/mixins/account-data/roles'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BBadge,
    BOverlay,
  },
  mixins: [rolesActions],
  setup() {
    const { setConfig, updateCurrentRole } = useRoles() //* Methods to load roles updateCurrentRole
    const toast = useToast()
    const configRol = ref({
      action: 5, id_rol: null, name_rol: null,
    })
    const isbusy = ref(null)
    // const { currentRole } = accountActions // Method to change user's rol
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    // guarda el perfil que usara en uac para uso de los demas servicios
    const activarPreferencias = inrol => {
      isbusy.value = true
      configRol.value.id_rol = inrol.id
      configRol.value.name_rol = inrol.nombre
      setConfig(configRol.value)
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              text: response,
              icon: 'UnlockIcon',
              variant: 'primary',
            },
          }, { timeout: 2000, position: 'top-center' })
          isbusy.value = false
          updateCurrentRole(inrol)
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atencion [Preferencias no firmadas]',
              text: error,
              icon: 'LockIcon',
              variant: 'danger',
            },
          }, { timeout: 8000 })
          isbusy.value = false
        })
    }

    return {
      // userRol,
      // rolesDisponibles,
      activarPreferencias,
      perfectScrollbarSettings,
      // flags
      isbusy,
    }
  },
}
</script>
